import { Component } from 'react';
import { toast_Time_out } from '../../Utility/Constants';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';

class ToastMsg extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toastOpen: true,
            vertical: this.props.msgtop ? 'top' : 'bottom',
            horizontal: this.props.msgtop ? 'center' : this.props.rightside ? 'right' : 'left'
        }
        this.lastMsg = null;
    }

    showToast = (msg) => {
        if (!msg || msg === this.lastMsg) return; // prevent duplicate
        this.lastMsg = msg;
        const message = (typeof msg === 'string' && msg) ? msg : "Something went wrong, please try again";

        enqueueSnackbar(message, {
            variant: this.props.severity,
            autoHideDuration: toast_Time_out,
            anchorOrigin: { vertical: this.state.vertical, horizontal: this.state.horizontal },
            invoice_number: this.props.testId,
            onExited: () => this.props.msgPop(),
            action: (id) => this.action(id),
        });
    };

    componentWillUnmount = () => {
        this.props.msgPop()
    }

    componentDidMount = () => {
        if (this.props.msg) {
            this.showToast(this.props.msg);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.msg !== prevProps?.msg) {
            this.showToast(this.props.msg);
        }
    }

    action = snackbarId => (
        <IconButton onClick={() => { closeSnackbar(snackbarId) }}>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' style={{ filter: 'brightness(0) invert(1)', height: "1vw" , width: "1vw" }} />
        </IconButton>
    );

    render() {
        return null //SnackbarProvider added in App.js
    }
}

export default ToastMsg;